/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import ChainingManagementContext from './ChainingManagementContext.vue'

export * from './ChainingManagementContext.vue'
export default ChainingManagementContext
